export const TRACKER_ATTR = 'data-dead-air-tracker';
export const ZONE_ATTR = 'data-dead-air-zone';
export const ZONE_TYPE_ATTR = 'data-dead-air-zone-type';
